import { Loader2 } from 'lucide-react';

export default function Button({
  children,
  variant = 'primary', // 'primary' | 'secondary' | 'ghost' | 'danger'
  size = 'md',         // 'sm' | 'md' | 'lg'
  icon: Icon,
  iconRight: IconRight,
  loading = false,
  fullWidth = false,
  className = '',
  disabled = false,
  onClick,
  type = 'button',
  ...props
}) {
  const classes = [
    'btn',
    `btn--${variant}`,
    size !== 'md' ? `btn--${size}` : '',
    fullWidth ? 'btn--full' : '',
    loading ? 'btn--loading' : '',
    className,
  ].filter(Boolean).join(' ');

  return (
    <button
      type={type}
      className={classes}
      disabled={disabled || loading}
      onClick={onClick}
      {...props}
    >
      {loading ? (
        <Loader2 className="spin" size={18} />
      ) : (
        Icon && <Icon size={18} />
      )}
      {children && <span>{children}</span>}
      {!loading && IconRight && <IconRight size={18} />}
    </button>
  );
}


export function IconButton({
  icon: Icon,
  variant = 'secondary',
  size = 'md',
  className = '',
  onClick,
  ...props
}) {
  return (
    <Button
      variant={variant}
      size={size}
      className={`btn--icon ${className}`}
      onClick={onClick}
      {...props}
    >
      {Icon && <Icon />}
    </Button>
  );
}
